import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import UiuxPageHero from "./components/UiuxPageHero";
import UiuxIntroSection from "./components/UiuxIntroSection";
import UiuxWhyChoose from "./components/UiuxWhyChoose";
import UiuxServicesSection from "./components/UiuxServicesSection";
import UiuxProcess from "./components/UiuxProcess";
import UiuxTechnologies from "./components/UiuxTechnologies";
import WdevStats from "../WebDevelopmentPage/components/WdevStats";
import WdevTestimonials from "../WebDevelopmentPage/components/WdevTestimonials";
import WdevCtaBanner from "../WebDevelopmentPage/components/WdevCtaBanner";
import "../WebDevelopmentPage/web-development.css";
import "./ui-ux-design.css";

const UiUxDesignPage: React.FC = () => {
  useEffect(() => {
    document.title = "UI/UX Design Company in Bangalore | WebTech Software Solutions";
    const description =
      "WebTech is a top UI/UX design agency in Bangalore. We craft user-centered interfaces through research, wireframes, and prototypes for web and mobile.";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);

  return (
    <Fragment>
      <div className="wdev-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <UiuxPageHero />
            <UiuxIntroSection />
            <UiuxWhyChoose />
            <UiuxServicesSection />
            <UiuxProcess />
            <UiuxTechnologies />
            <WdevStats />
            <WdevTestimonials />
            <WdevCtaBanner />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default UiUxDesignPage;
